"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/ui/button";
import { Link } from "@/i18n/routing";
import { ChevronDownIcon, ChevronUpIcon, LinkIcon, QuoteIcon } from "lucide-react";
import * as motion from "motion/react-client";
import { useTranslations } from "next-intl";
import { useState } from "react";
const INITIAL_COUNT = 4;
const testimonials = [{
  author: "Francesco Guadagno",
  role: "Cliente",
  date: "28 febbraio 2026",
  text: "Ho avuto il piacere di collaborare con Alain per lo sviluppo della mia App e posso affermare con convinzione che si tratta di un professionista altamente competente e affidabile. Ha dimostrato fin da subito grande preparazione tecnica, capacità di analisi e una visione chiara del progetto, trasformando le esigenze iniziali in una soluzione digitale funzionale, intuitiva e ben strutturata. Ho particolarmente apprezzato la sua disponibilità costante, la chiarezza nella comunicazione e l'attenzione ai dettagli, oltre alla capacità di proporre soluzioni migliorative durante tutto il percorso di sviluppo. Consiglio vivamente Alain a chiunque sia alla ricerca di uno sviluppatore serio e preparato."
}, {
  author: "CiNESpOt - produzioni",
  role: "Laurea in Cinema e Distribuzione",
  date: "22 dicembre 2025",
  text: "È stato un piacere e un'esperienza estremamente arricchente lavorare con Alain Di Fabio al progetto della nostra recente app mobile. Alain ha dimostrato una profonda competenza tecnica e una notevole creatività in ogni fase dello sviluppo. In particolare, la sua capacità di trasformare requisiti complessi in funzionalità utente intuitive, ma soprattutto garantire l'efficienza del backend è stata fondamentale per il successo del progetto. È un problem solver eccezionale, sempre pronto a esplorare nuove soluzioni e ad affrontare le sfide con un approccio proattivo e analitico. Oltre alle sue capacità tecniche, ho apprezzato la sua dedizione e la sua eccellente comunicazione all'interno del team. Consiglio vivamente Alain a chiunque cerchi un professionista affidabile, competente e che apporti un valore reale a qualsiasi progetto di sviluppo. Spero sinceramente di avere l'opportunità di collaborare nuovamente con lui in futuro!"
}, {
  author: "Daniele Tesei",
  role: "Owner at TESEI",
  date: "1 febbraio 2025",
  text: "Lavorare con Alain è stata un'esperienza estremamente positiva. Ha realizzato una web app fondamentale per la nostra azienda, dimostrando una comprensione immediata delle nostre esigenze e trasformando le nostre idee in una soluzione concreta e performante. La sua brillantezza e la capacità di cogliere al volo le necessità del cliente sono state fondamentali per il successo del progetto, che è stato completato nei tempi previsti superando le nostre aspettative. Consiglio Alain a chi cerca un professionista affidabile, competente e orientato al risultato."
}, {
  author: "Gaetano Cuomo",
  role: "Laurea in Scienze dell'Informazione",
  date: "6 aprile 2022",
  text: "Conosco Alain di Fabio da poco, ma posso sicuramente affermare che è un professionista e ha sviluppato per me un App veramente eccellente. È competente e diligente, e si è dedicato al progetto in maniera esemplare producendo un risultato ottimo sotto tutti i punti di vista. Complimenti Alain."
}, {
  author: "Salvatore Sena",
  role: "Full Stack Developer VB.NET, ASP.NET, mySQL, SQL Server, App Flutter",
  date: "6 aprile 2022",
  text: "Ottimo professionista, developer iOS e android esperto che ha realizzato in breve tempo l'app commissionata. Un partner di qualità."
}, {
  author: "Flavio Astorino",
  role: "Senior Cybersecurity Expert, CISM",
  date: "1 aprile 2022",
  text: "Alain e' una persona ricca di idee e proposte che mette a disposizione di chiunque abbia bisogno di lui nel proprio progetto. Tecnicamente e' molto preparato e aggiornato sulle ultime tecnologie, si muove con scioltezza su ambiti tecnologici molto ampi ed e' sempre costruttivo e disponibile a supportare le persone con cui collabora."
}, {
  author: "Stefania Curcio",
  role: "Gestione Clienti e coordinamento Team",
  date: "18 gennaio 2020",
  text: "Alain è un vulcano di idee, sempre pronto a confrontarsi e a mettersi in discussione. La sua competenza e la sua passione lo rendono un ottimo trascinatore, coinvolgendo tutti nei suoi progetti. Curioso e stimolante, riesce a trasmettere i suoi valori e le sue idee con estrema facilità e chiarezza. Lavorare con lui è un'opportunità di crescita professionale e personale, un'esperienza che arricchisce in maniera unica."
}, {
  author: "Loredana Cafarda",
  role: "Senior Account Manager",
  date: "11 gennaio 2020",
  text: "Alain è una persona appassionata e competente. Crede molto nella sua attività e trasmette una enorme e coinvolgente energia. Collaborare con Alain è un'esperienza stimolante e arricchente."
}, {
  author: "Marco Ottaviani",
  role: "Client Manager @ Maps Healthcare spa. PhD in industrial and management engineering",
  date: "11 gennaio 2020",
  text: "Alain è un professionista dinamico e pieno di idee, riesce a illustrare le sue iniziative e fornire soluzioni in modo intelligente e carismatico. Molto stimolante lavorare in team con lui!"
}, {
  author: "Mattia Nocco",
  role: "Empowering clubs by transforming football scouting into measurable business growth",
  date: "11 gennaio 2020",
  text: "Reputo Alain un ottimo professionista. Il suo approccio professionale si spinge oltre la consulenza tradizionale ed assume una forma più istruttiva e formativa. Il suo lavoro mi ha molto aiutato a valutare nuovi punti di vista e a valutare diverse nuove soluzioni."
}, {
  author: "Filippo Carditello",
  role: "AI Strategist - Soluzioni di Intelligenza Artificiale per PMI e Professionisti",
  date: "7 gennaio 2020",
  text: "Grande professionista con esperienza, sa individuare le esigenze del cliente molto rapidamente con una visione a 360 gradi, serietà e precisione al primo posto tra le sue caratteristiche."
}];
const Testimonials = () => {
  const $ = _c(41);
  const t = useTranslations("Home");
  const [showAll, setShowAll] = useState(false);
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] !== showAll || $[1] !== t) {
    const visible = showAll ? testimonials : testimonials.slice(0, INITIAL_COUNT);
    t2 = "flex flex-col gap-8";
    let t4;
    let t5;
    let t6;
    let t7;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = {
        opacity: 0
      };
      t5 = {
        opacity: 1
      };
      t6 = {
        once: true
      };
      t7 = {
        duration: 0.5,
        ease: "easeOut"
      };
      $[6] = t4;
      $[7] = t5;
      $[8] = t6;
      $[9] = t7;
    } else {
      t4 = $[6];
      t5 = $[7];
      t6 = $[8];
      t7 = $[9];
    }
    let t8;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <LinkIcon className="size-4 shrink-0" />;
      $[10] = t8;
    } else {
      t8 = $[10];
    }
    let t9;
    if ($[11] !== t) {
      t9 = t("sections.testimonials.linkedinNote");
      $[11] = t;
      $[12] = t9;
    } else {
      t9 = $[12];
    }
    if ($[13] !== t9) {
      t3 = <motion.div initial={t4} whileInView={t5} viewport={t6} transition={t7} className="flex items-center gap-2 text-sm text-muted-foreground">{t8}<p>{t9}</p></motion.div>;
      $[13] = t9;
      $[14] = t3;
    } else {
      t3 = $[14];
    }
    t0 = "grid grid-cols-1 md:grid-cols-2 gap-5";
    t1 = visible.map(_temp);
    $[0] = showAll;
    $[1] = t;
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t0 = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  let t4;
  if ($[15] !== t0 || $[16] !== t1) {
    t4 = <div className={t0}>{t1}</div>;
    $[15] = t0;
    $[16] = t1;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      opacity: 0,
      translateY: 10
    };
    t6 = {
      opacity: 1,
      translateY: 0
    };
    t7 = {
      once: true
    };
    t8 = {
      delay: 0.3,
      duration: 0.5,
      ease: "easeOut"
    };
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t5 = $[18];
    t6 = $[19];
    t7 = $[20];
    t8 = $[21];
  }
  let t9;
  if ($[22] !== showAll || $[23] !== t) {
    t9 = testimonials.length > INITIAL_COUNT && <motion.div whileHover={{
      scale: 1.04
    }} whileTap={{
      scale: 0.97
    }} transition={{
      type: "spring",
      stiffness: 400,
      damping: 17
    }}><Button type="button" variant="outline" size="sm" onClick={() => setShowAll(!showAll)}>{showAll ? <><ChevronUpIcon className="size-4" />{t("sections.testimonials.showLess")}</> : <><ChevronDownIcon className="size-4" />{t("sections.testimonials.showAll", {
            count: testimonials.length
          })}</>}</Button></motion.div>;
    $[22] = showAll;
    $[23] = t;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  let t11;
  let t12;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      scale: 1.04
    };
    t11 = {
      scale: 0.97
    };
    t12 = {
      type: "spring",
      stiffness: 400,
      damping: 17
    };
    $[25] = t10;
    $[26] = t11;
    $[27] = t12;
  } else {
    t10 = $[25];
    t11 = $[26];
    t12 = $[27];
  }
  let t13;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <LinkIcon className="size-3.5" />;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t) {
    t14 = t("sections.testimonials.viewAllOnLinkedin");
    $[29] = t;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t14) {
    t15 = <Link href="https://www.linkedin.com/in/alaindifabio/details/recommendations/" target="_blank"><motion.div whileHover={t10} whileTap={t11} transition={t12}><Button type="button" variant="outline" size="sm" className="gap-2">{t13}{t14}</Button></motion.div></Link>;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t15 || $[34] !== t9) {
    t16 = <motion.div initial={t5} whileInView={t6} viewport={t7} transition={t8} className="flex flex-wrap items-center justify-center gap-3">{t9}{t15}</motion.div>;
    $[33] = t15;
    $[34] = t9;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t16 || $[37] !== t2 || $[38] !== t3 || $[39] !== t4) {
    t17 = <div className={t2}>{t3}{t4}{t16}</div>;
    $[36] = t16;
    $[37] = t2;
    $[38] = t3;
    $[39] = t4;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  return t17;
};
export default Testimonials;
function _temp(testimonial, index) {
  return <motion.div key={index} initial={{
    translateY: 30,
    opacity: 0
  }} whileInView={{
    translateY: 0,
    opacity: 1
  }} viewport={{
    once: true,
    margin: "-30px"
  }} transition={{
    duration: 0.5,
    delay: index * 0.08,
    ease: "easeOut"
  }} whileHover={{
    translateY: -4
  }} className="group relative flex flex-col bg-card border border-border rounded-xl p-6 gap-4 transition-all duration-300 hover:border-[hsl(var(--accent))]/20 hover:glow-accent"><div className="absolute left-0 top-6 bottom-6 w-0.5 rounded-full bg-[hsl(var(--accent))]/20 group-hover:bg-[hsl(var(--accent))]/40 transition-colors duration-300" /><QuoteIcon className="size-5 text-[hsl(var(--accent))]/30" /><p className="text-sm text-foreground/85 leading-[1.8] flex-1 pl-2">{testimonial.text}</p><div className="flex items-center justify-between pt-4 border-t border-border/60 pl-2"><div><div className="font-semibold text-sm text-foreground">{testimonial.author}</div><div className="text-xs text-muted-foreground mt-0.5">{testimonial.role}</div></div><div className="text-[11px] font-mono text-muted-foreground/50 shrink-0 ml-4">{testimonial.date}</div></div></motion.div>;
}